import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RequestStatus } from '../../../../models/request-status.model';

@Component({
    selector: 'app-status-card',
    templateUrl: './status-card.component.html',
    styleUrls: ['./status-card.component.scss'],
})
export class StatusCardComponent {
    @Input() status: RequestStatus;
    @Input() statusType: string = '';

    @Output() edit = new EventEmitter<string>();

    @Output() delete = new EventEmitter<RequestStatus>();

    constructor(private translate: TranslateService) {}

    onEdit(): void {
        this.edit.emit(this.status._id);
    }

    onDelete(): void {
        this.delete.emit(this.status);
    }
}
